import React, {useState} from 'react';
import TacheUpdateView from './TacheUpdateView';
import {updateTache, addTache} from '../../../../services/MadricService';

/**
 *  L'accueil
 * @param {*} props props
 * @return {JSX}
 */
function TacheUpdate(props) {
  const [inputValue, setInputValue] = useState(props.isUpdate ? props.selectedTache.name : '');
  const [color, setColor] = useState(props.isUpdate ? props.selectedTache.color : '#D21919');
  const [errors, setErrors] = useState('');

  /**
   * Permet de submit la tache
   */
  async function handleSubmit() {
    setErrors('');
    let error = false;

    if (inputValue === '') {
      error = true;
      setErrors('Le nom de la tâche ne peut pas être vide');
    }

    if (!error) {
      props.setIsLoading(true);
      const res = props.isUpdate ? await updateTache(props.selectedTache.id, inputValue, color) : await addTache(inputValue, color);
      props.setIsLoading(false);
      props.setTaches(res);
      setInputValue('');
      props.closeModal();
      setErrors('');
    }
  };

  return (
    <TacheUpdateView
      closeModal={props.closeModal}
      isUpdate={props.isUpdate}
      setColor={setColor}
      color={color}
      inputValue={inputValue}
      setInputValue={setInputValue}
      errors={errors}
      handleSubmit={handleSubmit}
    />
  );
}

export default TacheUpdate;
